export default class BaseFilter {
    constructor() {
        this.DOM = {
            body: "body",
        };

        this.body = document.querySelector(this.DOM.body);
    }

    getBodyElement() {
        return this.body;
    }

    disableFilter() {
        this.getBodyElement().classList.add("is-filter-disabled");
    }

    enableFilter() {
        this.getBodyElement().classList.remove("is-filter-disabled");
    }

    isFilterInProgress() {
        return this.getBodyElement().classList.contains("is-filter-disabled");
    }

    getGlobalApiUrl() {
        return this.getBodyElement().getAttribute("data-api-url");
    }

    getApiUrlFromElement(class_name) {
        if (document.querySelector(class_name) !== null) {
            return document.querySelector(class_name).getAttribute("data-url");
        }

        return "";
    }

    updateUrls(stateData, url) {
        history.pushState(stateData, document.title, url);
    }
}
